#version 300 es
/*
* Preprocessed + Optimized from './vignette.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;
in vec2 vPosition;

void main()
{
    vec4 _43 = texture(uTexture, vTextureCoord);
    fragColor = vec4(_43.xyz * smoothstep(-0.3499999940395355224609375, 0.3499999940395355224609375, (1.0 - u_intensity) - distance(vPosition, vec2(0.5))), _43.w);
}
